module.exports = __webpack_public_path__ + "img/wig-1.e6140755.svg";